import { bootstrapMap } from './map.js';
import { setupEventListeners } from './events.js';
import { loadOnlineBuisnesses } from './api.js';

/**
 * Initialize everything when DOM is ready
 */
document.addEventListener('DOMContentLoaded', () => {
    bootstrapMap();
    setupEventListeners();
    loadOnlineBuisnesses();
});
